import { encryptedPost } from "../utils/secureApi";

/**
 * Master Data Service — single source of truth for all shared API functions.
 * All modules import from here instead of defining their own copies.
 */

export const fetchCompanies = () => encryptedPost("/companies/list", {});
export const fetchStores = () => encryptedPost("/stores/list", {});
export const fetchVendors = () => encryptedPost("/vendors/list", {});
export const fetchCustomers = () => encryptedPost("/customers/list", {});
export const fetchUsers = () => encryptedPost("/users/list", {});
export const fetchProducts = () => encryptedPost("/products/list", {});
export const fetchRoles = () => encryptedPost("/userRoles/list", {});
